import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import _ from 'lodash'

const CheckmarxMappingForm = forwardRef(function CheckmarxMappingForm({disableProjectFields = false, ...props}, ref) {
  const [projects, setProjects] = useState([]);
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });
  
  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(modifyOption(projects));
    }).catch(() => {
      message.error('Problem fetching projects');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { projectId } = config;
  
    const data = projects.reduce((acc,cv) =>{
      const { name, options } = cv;
      _.forEach(options, opt => {
        if(projectId.includes(opt.value)){
          acc.id.push(opt.value);
          acc.name.push(opt.label);
          acc['teamName'] = name;
        }
      })
     
      return acc;
    },{id:[],name:[]})

    return ({
      projectId:data.id.join(),
      projectName:data.name.join(),
      teamName: data.teamName,
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return {  projectId:config.projectId.split(','),
    //send the property received in config
    ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id }) };
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'projectId',
      colSpan: '24',
      type: FieldTypes.MULTI_SELECT,
      label: 'Checkmarx Project',
      options: projects,
      disabled: disableProjectFields,
      rules: [{ required: true, message: `Checkmarx Project is required` }],
      props: {
        autoFocus: !disableProjectFields
      }
    }
  ]), [projects, disableProjectFields]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      formDefaultValues={initialValues}
      {...props}
    />
  )
})

export default CheckmarxMappingForm;

const modifyOption = (options) => {
  const optionObj = {};
  options.forEach(opt=> {
    if(!optionObj[opt?.otherProperties?.teamName]){
      optionObj[opt.otherProperties.teamName] = [];
    }
    if(optionObj[opt?.otherProperties?.teamName]) optionObj[opt.otherProperties.teamName].push({label: opt.name, value: opt.id })
  })
  return Object.keys(optionObj).map(key=> {
    return {
      name: key,
      options: optionObj[key]
    }
  })
}
